import { KeyedMutator } from "swr";

export enum FilterShape {
  ReadFilter = 1,
  BatchFilter = 2,
  IndicatorFilter = 3,
  ClientFilter = 4,
  RiskRatingFilter = 5,
  DateRangeFilter = 6,
}

export enum FilterSource {
  Static = 1,
  Query = 2,
}

export enum FilterSelectionMode {
  Single = 1,
  Multi = 2,
}

export enum FilterDefaultVisibility {
  VisibleToAll = 1,
  HiddenByDefault = 2,
}

export interface FilterOptionDetail {
  id: number;
  filterTypeId: number;
  code: string;
  description: string;
  isEnabled: boolean;
  isDefaultSelected: boolean;
  isSynthetic: boolean;
  sortOrder: number;
  meta?: string | null;
}

export interface FilterTypeDetail {
  id: number;
  shapeId: FilterShape;
  source: FilterSource;
  selectionMode: FilterSelectionMode;
  isEnabled: boolean;
  isDropdown: boolean;
  defaultVisibility: FilterDefaultVisibility;
  isSystem: boolean;
  sortOrder: number;
  optionCount: number;
  code: string;
  label: string;
  targetField?: string | null;
  targetColumn?: string | null;
  createdUtc: string;
  modifiedUtc?: string | null;
  options: FilterOptionDetail[];
}

export interface FilterShapeDetail {
  id: number;
  code: string;
  description?: string | null;
  inUseCount: number;
}

export interface FilterClientVisibility {
  filterCode: string;
  filterTypeId: number;
  clientId: number;
  isEnabled: boolean;
  modifiedUtc: string;
  modifiedBy?: string | null;
}

export interface CreateFilterTypeRequest {
  shapeId: FilterShape;
  source: FilterSource;
  sortOrder?: number | null;
  code: string;
  label: string;
  selectionMode: FilterSelectionMode;
  isEnabled: boolean;
  isDropdown: boolean;
  defaultVisibility: FilterDefaultVisibility;
  targetField?: string | null;
  targetColumn?: string | null;
}

export interface UpdateFilterTypeRequest {
  id: number;
  shapeId: FilterShape;
  source: FilterSource;
  selectionMode: FilterSelectionMode;
  isEnabled: boolean;
  isDropdown: boolean;
  defaultVisibility: FilterDefaultVisibility;
  sortOrder: number;
  label: string;
  targetField?: string | null;
  targetColumn?: string | null;
  isSystem: boolean;
}

export interface CreateFilterOptionRequest {
  filterTypeId: number;
  isDefaultSelected: boolean;
  isSynthetic: boolean;
  sortOrder?: number | null;
  meta?: string | null;
  code: string;
  description: string;
  isEnabled: boolean;
}

export interface UpdateFilterOptionRequest {
  id: number;
  isEnabled: boolean;
  isDefaultSelected: boolean;
  sortOrder: number;
  meta?: string | null;
  description: string;
}

export interface UseFilterTypesModel {
  data: FilterTypeDetail[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: KeyedMutator<FilterTypeDetail[]>;
}

export interface UseFilterShapesModel {
  data: FilterShapeDetail[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: KeyedMutator<FilterShapeDetail[]>;
}
